import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Importer les fichiers de traduction
import translationFR from './locales/fr/translation.json';
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';
import translationPT from './locales/pt/translation.json';

// Configuration d’i18next
i18n
  .use(initReactI18next) // passer i18n à react-i18next
  .init({
    resources: {
      FRA: {
        translation: translationFR,
      },
      ENG: {
        translation: translationEN,
      },
      ESP: {
        translation: translationES,
      },
      POT: {
        translation: translationPT,
      },
    },
    lng: "FRA", // langue par défaut
    fallbackLng: "FRA", // langue de repli
    interpolation: {
      escapeValue: false, // Pas d'échappement, React gère déjà cela
    },
  });

export default i18n;
